<!--
 * @Author: your name
 * @Date: 2021-01-20 14:06:23
 * @LastEditTime: 2021-03-04 14:45:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xy_project\src\views\Home\common\MonitorDialog.vue
-->
<template>
  <div id='monitorDialog'>
    <!-- 监控管理平台对话框 -->
    <el-dialog title="监控管理平台" :visible.sync="monitorVisible" width="30%" custom-class="monitorVisible" @close="closeMonitorDialog">
      <el-form :model="monitorForm" :rules="monitorFormRules" ref="monitorForm" label-width="130px" class="demo-ruleForm">
        <el-form-item label="账户名：" prop="userName">
          <el-input v-model="monitorForm.userName" autocomplete="off" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码：" prop="password">
          <el-input auto-complete="new-password" type="password" placeholder="请输入密码" v-model="monitorForm.password" @keyup.enter.native="monitorLogin"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <span class="button add" type="primary" @click="monitorLogin">登录</span>
        <span class="button" @click="cancelMonitor">取 消</span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { loginMonitoring } from '@/api/index'
export default {

  data() {
    return {
      monitorVisible: false,
      monitorForm: {
        userName: '',
        password: ""
      },
      monitorFormRules: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
      },
      companyname: '',
      companyid: '',
      id: '',
      // loginId: 0,
      nowTime: "",  //记录所有数据已读的时间
    }
  },
  created() { },
  methods: {
    // 商安信接口
    monitorLogin() {
      this.$refs.monitorForm.validate(async (valid) => {
        if (valid) {
          const { data } = await loginMonitoring(this.monitorForm)
          if (data.code == 0) {
            if (this.$parent.name == 'management') {
              window.open(`${this.$saxloginurl}/#/track-overview-param/${data.accountStatus}/${data.accountType}/${data.token}`)
            } else if (this.$parent.name == 'todo') {
              // 测试地址
              window.open(`${this.$saxloginurl}/#/track-details-param/${data.accountStatus}/${data.accountType}/${data.token}/${this.companyname}/${this.companyid}`)
              this.loginId = 2
              this.$parent.isShowMonitor = false
              this.monitorVisible = false

              const index = this.$parent.monitorData.findIndex(item => item.id === this.id)
              //移除索引对应的数据
              this.$parent.monitorData.splice(index, 1)
              localStorage.setItem('monitorData', JSON.stringify(this.$parent.monitorData))
              if (this.$parent.monitorData.length == 0) {
                // this.nowTime = this.$dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
                localStorage.setItem('nowTime', this.$dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'))
              }
              this.$parent.$parent.$parent.$parent.getMonitorData()
            }
          } else {
            this.$message.error(data.msg)
            this.$parent.isShowMonitor = true

          }
        }
      })
    },
    closeMonitorDialog() {
      this.$refs.monitorForm.resetFields()
      this.$parent.isShowMonitor = false

    },
    cancelMonitor() {
      this.monitorVisible = false
      this.$parent.isShowMonitor = false
    }
  }
}
</script>
<style lang='less' scoped>
</style>